import {
  JOURNEY_TYPE,
  RAIL_EUROPE_TRAIN_CATEGORY_TYPE,
  TRAIN_PLACE_TYPE,
  TRAIN_PLACE_SPLIT_SYMBOL,
} from '~constants/pointToPointTicket';

import type {
  OptionalRailEuropeTrainQueryParam,
  RailEuropeTrainCategoryType,
} from '~types/queryParam';

export interface ParsedQueryResult {
  category: RailEuropeTrainCategoryType;
  isSingleTrip: boolean;
  origin: {
    place: string;
    type: (typeof TRAIN_PLACE_TYPE)[keyof typeof TRAIN_PLACE_TYPE];
    code: string;
  };
  destination: {
    place: string;
    type: (typeof TRAIN_PLACE_TYPE)[keyof typeof TRAIN_PLACE_TYPE];
    code: string;
  };
  departureDate?: string;
  arrivalDate?: string;
  travelersCount: number;
  ageList: number[];
  outboundDepartureTime?: string;
  inboundDepartureTime?: string;
}

/**
 * 레일유럽 검색 쿼리 파라미터를 파싱하는 유틸리티 함수
 */
const parseRailEuropeQueryParams = (
  queries: OptionalRailEuropeTrainQueryParam,
): ParsedQueryResult => {
  const {
    category,
    journey,
    origin: originQuery,
    destination: destinationQuery,
    departureDate,
    arrivalDate,
    ages,
    outboundDepartureTime: outboundDepartureTimeQuery,
    inboundDepartureTime: inboundDepartureTimeQuery,
  } = queries;

  const [originCity, originType, originCode] = originQuery?.split(TRAIN_PLACE_SPLIT_SYMBOL) || [];
  const originObj = {
    place: originCity ? decodeURIComponent(originCity) : '',
    type: originType as (typeof TRAIN_PLACE_TYPE)[keyof typeof TRAIN_PLACE_TYPE],
    code: originCode,
  };

  const [destinationCity, destinationType, destinationCode] =
    destinationQuery?.split(TRAIN_PLACE_SPLIT_SYMBOL) || [];
  const destinationObj = {
    place: destinationCity ? decodeURIComponent(destinationCity) : '',
    type: destinationType as (typeof TRAIN_PLACE_TYPE)[keyof typeof TRAIN_PLACE_TYPE],
    code: destinationCode,
  };

  const travelersCount = ages ? decodeURIComponent(ages).split(',').length : 0;
  const ageList = ages
    ? decodeURIComponent(ages)
        .split(',')
        .map((age) => parseInt(age))
    : [];

  const isSingleTrip = journey ? journey === JOURNEY_TYPE.ONE_WAY : true;

  const outboundDepartureTime = outboundDepartureTimeQuery
    ? decodeURIComponent(outboundDepartureTimeQuery.replace(/:00:00/, ':00'))
    : undefined;

  const inboundDepartureTime = inboundDepartureTimeQuery
    ? decodeURIComponent(inboundDepartureTimeQuery.replace(/:00:00/, ':00'))
    : undefined;

  return {
    category: category || RAIL_EUROPE_TRAIN_CATEGORY_TYPE.TICKET,
    isSingleTrip,
    origin: originObj,
    destination: destinationObj,
    departureDate,
    arrivalDate,
    outboundDepartureTime,
    inboundDepartureTime,
    travelersCount,
    ageList,
  };
};

export default parseRailEuropeQueryParams;
